import {
  AboutServerTabs,
  type AboutServerSectionProps,
} from '@wellesley/server-info'
import BackButton from 'components/BackButton'
import { FC } from 'react'

export const AboutHostServerSection: FC<
  Omit<AboutServerSectionProps, 'serverInfoData'>
> = ({
  isLoading,
  showBlockedDomainsTab,
  showBlockedDomainsReason,
  description,
  serverRules,
  stats,
  contacts,
}) => {
  return (
    <div className="relative flex h-[calc(100vh-32px)] w-[760px] flex-col items-center  overflow-y-auto rounded-lg bg-white">
      <div className="relative m-m flex w-full items-center justify-center">
        <BackButton
          isText={false}
          title="Back"
          className="absolute left-m text-gray-400"
        />
        <h2 className="text-lg font-semibold text-gray-700">About server</h2>
      </div>
      <AboutServerTabs
        isLoading={isLoading}
        showBlockedDomainsTab={showBlockedDomainsTab}
        showBlockedDomainsReason={showBlockedDomainsReason}
        description={description}
        serverRules={serverRules}
        stats={stats}
        contacts={{
          email: contacts?.email || '',
          username: contacts?.username || '',
        }}
      />
    </div>
  )
}
